/**
 * @author rmh
 * 功能：库存查询
 */

import { Service } from '@/tools'

export class bookInventoryInquiryService<T extends TStock.bookInventoryInquiry> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(
    url: `${P}/${keyof TStock.bookInventoryInquiry}`,
    data?: TCommon.Json,
    toast?: string
  ) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：图书-非图库存分页
   */
  skuPage = (data: T['ApiSkuPage']['req']): Promise<T['ApiSkuPage']['res']> => {
    return this.post2('v1/ApiSkuPage', data)
  }

  /**
   * 模块说明：查询库存流水分页
   */
  bookLogPage = (data: T['ApiLogPage']['req']): Promise<T['ApiLogPage']['res']> => {
    return this.post2('v1/ApiLogPage', data)
  }

  /**
   * 模块说明：库存占用详情分页
   */
  bookStockPage = (data: T['ApiStockPage']['req']): Promise<T['ApiStockPage']['res']> => {
    return this.post2('v1/ApiStockPage', data)
  }

  /**
   * 模块说明：批次库存分页
   */
  bookBatchBatchPage = (data: T['ApiBatchPage']['req']): Promise<T['ApiBatchPage']['res']> => {
    return this.post2('v1/ApiBatchPage', data)
  }

  /**
   * 模块说明：批次详情查询
   */
  bookBatchDetail = (data: T['ApiBatchDetail']['req']): Promise<T['ApiBatchDetail']['res']> => {
    return this.post2('v1/ApiBatchDetail', data)
  }

  /**
   * 模块说明： 批次出入库明细分页
   */
  batchLogPage = (data: T['ApiBatchLogPage']['req']): Promise<T['ApiBatchLogPage']['res']> => {
    return this.post2('v1/ApiBatchLogPage', data)
  }
}
